import { render, staticRenderFns } from "./ObjectForm.vue?vue&type=template&id=33b0bd1d&"
import script from "./ObjectForm.vue?vue&type=script&lang=js&"
export * from "./ObjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports